import { FormSectionHandler } from '../entity.handler';
import { ThemeResponse, ThemeUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { EntityUtils } from '../utils';
import { getThemeDictionary, BaseTheme } from 'app/shared/components/theme/theme-dictionary';
import { pick } from 'lodash';

interface EditorValues {
    [key: string]: any;
}

export class LegacyThemeSettingsSectionHandler implements FormSectionHandler<ThemeResponse, EditorValues> {

    type = 'form';
    icon = 'fill';
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    themeDictionary = getThemeDictionary();

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.THEME.SETTINGS.${key}`, values);
    }

    applyUpdate(entity: ThemeResponse, payload: ThemeUpdateRequest): Promise<ThemeResponse> {
        return this.admin.applyUpdate(api => api.entities.updateTheme(entity.id, payload), { _type: 'theme' });
    }

    async mapEntityToEditor(entity: ThemeResponse): Promise<EditorValues> {

        const base = this.themeDictionary[entity.theme] as BaseTheme;       
        const fields = (base && base.getSettingsForm(this.admin.i18n).groups[0].fields) || [];

        // Only pull out the values that we are actually going to need in the form
        const keys = [];
        fields.map(field => {
            keys.push(field.id);
            if (field.type === 'swatches') {
                field.values.forEach(val => {
                    keys.push(val.key);
                });
            }
        });
        const settings = {
            ...pick(base.settings, keys), 
            ...entity.settings,
        };
        return settings;
    }

    async mapEditorToEntity(entity: ThemeUpdateRequest, values: EditorValues): Promise<ThemeUpdateRequest> {
        entity.settings = {
            ...entity.settings,
            ...values,
        };
        return entity;
    }

    async getFields(entity: ThemeResponse): Promise<FormBuilderField[]> {
        const base = this.themeDictionary[entity.theme] as BaseTheme;
        const fields = base && base.getSettingsForm(this.admin.i18n).groups[0].fields || [];
        return EntityUtils.prepareBulk(!entity, [], fields);
    }

}
